<template>
    <div class="flex-column">
        <div>
            <div v-if="hasModes">
                <div v-for="option in filter.inputs.mode.options" :key="option.value">
                    <div class="form-group">
                        <label class="form-label label-auto" :for="'mode' + option.value">
                            <input
                                :id="'mode' + option.value"
                                v-model="mode"
                                type="radio"
                                :value="option.value"
                            />
                            {{ option.label }}
                        </label>
                    </div>
                </div>
            </div>
            <div v-show="mode === 'is'" :class="{ 'ml-4': hasModes }">
                <div class="form-group">
                    <input
                        id="checkUncheck"
                        type="checkbox"
                        value=""
                        name="checkUncheck"
                        :checked="
                            choices.length === Object.values(filter.inputs.choices.options).length
                                ? true
                                : false
                        "
                        @click.prevent="toggleCheckAll()"
                    />
                    <label for="checkUncheck">
                        {{
                            choices.length === Object.values(filter.inputs.choices.options).length
                                ? $l10n.__('Tout décocher')
                                : $l10n.__('Tout cocher')
                        }}
                    </label>
                </div>

                <div v-for="option in filterOptions" :key="option.value" class="form-group">
                    <label class="form-label label-auto" :for="'opt-' + option.value">
                        <input
                            :id="'opt-' + option.value"
                            v-model="choices"
                            type="checkbox"
                            name="options[]"
                            :value="option.value"
                        />
                        {{ option.label }}
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ListingFilterMixin from './ListingFilterMixin.js';

export default {
    mixins: [ListingFilterMixin],
    data() {
        return {
            choices: [],
            mode: 'is',
        };
    },

    computed: {
        data() {
            return {
                choices: this.choices,
                mode: this.mode,
            };
        },
        allselected() {
            return Object.values(this.filter.inputs.choices.options).length === this.choices.length;
        },
        noneselected() {
            return !this.choices.length;
        },

        hasModes() {
            return Object.keys(this.filter.inputs.mode.options).length > 1;
        },
        filterOptions() {
            const rankedList = Object.values(this.filter.inputs.choices.options).sort((a, b) => {
                if (!a.rank) {
                    a.rank = 0;
                }
                if (!b.rank) {
                    b.rank = 0;
                }
                return a.rank - b.rank;
            });
            return rankedList;
        },
    },

    watch: {
        choices() {
            const cb = document.getElementById('checkUncheck');
            cb.indeterminate = !this.allselected && !this.noneselected;
        },
    },

    methods: {
        toggleCheckAll() {
            if (this.choices.length === Object.values(this.filter.inputs.choices.options).length)
                this.choices = [];
            else {
                this.choices = [];
                Object.values(this.filter.inputs.choices.options).forEach((option) =>
                    this.choices.push(option.value),
                );
            }
        },
    },
};
</script>
